import { inject, Injectable } from '@angular/core';
import { queryOptions, UndefinedInitialDataOptions } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { CoreApiService } from './core-api.service';
import { User } from './shared/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class ProfileQueryService {
  private coreApi = inject(CoreApiService);

  getProfile(): UndefinedInitialDataOptions<User> {
    return queryOptions({
      queryKey: ['self', 'profile'],
      queryFn: () => lastValueFrom(this.coreApi.users.self()),
      refetchOnMount: false,
    });
  }
}
